import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, OnInit, OnDestroy } from '@angular/core';

import { ApiError, ConfigServerService, JwtService, MessageService } from '../../../../core';
import { PessoaTermoLGPD } from '../pessoa-termo-lgpd';
import { PessoaTermoLGPDHttpService } from '../services';
import { FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';

@Component({
    selector: 'sgt-pessoa-termo-lgpd-file-upload',
    templateUrl: './pessoa-termo-lgpd-file-upload.component.html',
    styleUrls: ['./pessoa-termo-lgpd-file-upload.component.less']
})
export class PessoaTermoLGPDFileUploadComponent implements OnInit, OnDestroy {
    @Input() entity: PessoaTermoLGPD;
    @Output() entityChange = new EventEmitter<PessoaTermoLGPD>();

    @ViewChild('inputFile') inputFile: ElementRef;
    uploader: FileUploader;

    constructor(private configServerService: ConfigServerService,
                private jwtService: JwtService,
                private messageService: MessageService,
                private pessoaTermoLGPDHttpService: PessoaTermoLGPDHttpService) { }

    ngOnInit(): void {
        this.create();
    }

    // Cria o uploader responsável por realizar o upload da imagem da assinatura de e-mail
    private create() {
        this.uploader = new FileUploader({autoUpload: true});
        this.uploader.options.method = 'PUT';
        this.uploader.options.url = `${this.configServerService.getPathApi()}/pessoatermolgpd/${this.entity.id}/anexar`;
        this.uploader.authToken = this.jwtService.accessTokenWithBearer;

        // Ao completear o upload da imagem
        this.uploader.onCompleteItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any => {
            switch (status) {
                case 200: // OK
                    // Recarregando as informações do Termo LGPD
                    this.pessoaTermoLGPDHttpService.load(this.entity.id)
                        .subscribe(
                            entity => {
                                this.entity = entity;
                                this.entityChange.emit(this.entity);
                            },
                            (err: ApiError) => this.messageService.error(err.message, 'Erro ao carregar as informações do Termo LGPD após anexar o termo. Recarregue a página para ver as informações atualizadas', err)
                        );

                    break;
                default: // Demais erros
                    const error = JSON.parse(response) as ApiError;
                    this.messageService.error(error.message, 'Erro ao realizar o upload do Termo LGPD', error);
                    break;
           }
       };

       // Após selecionar o arquivo
       this.uploader.onAfterAddingFile = (fileItem: FileItem): any => {
            fileItem.withCredentials = false;
        }

       // Ao completar o upload
       this.uploader.onCompleteAll = () => {
            this.clearInputFile();
            this.messageService.success('', 'Termo LGPD anexado com sucesso');
       };
    }

    // Limpa o input file
    private clearInputFile() {
        const el = this.inputFile.nativeElement as HTMLInputElement;
        el.value = '';
    }

    ngOnDestroy(): void {
        this.clearInputFile();
        this.uploader.destroy();
    }
}
